import Flux                   from '../../flux/Flux';
import GuestAccess            from '../../utils/GuestAccess';
import {VXPay}                from '../../utils/VXPay';
import {gaHelper, gtagHelper} from '../../utils/CommonUtils';
import EnumAnalyticsEvents    from '../../utils/EnumAnalyticsEvents';
import UrlHelper              from '../../utils/UrlHelper';
import EnumGA4Events          from "../../utils/EnumGA4Events";

export const OfferAction = {
	/**
	 * @param action
	 * @param label
	 */
	track(action, label) {
		gaHelper('send', 'event', EnumAnalyticsEvents.CATEGORY_365, action, label);
		gtagHelper(EnumGA4Events.DEFAULT_PARAMETER_EVENT, EnumGA4Events.CUSTOM_EVENT_CONVERSION_360, {
			[EnumGA4Events.CUSTOM_PARAMETER_CONVERSION_360_ACTION]: action,
		});
	},
	/**
	 * @param {String} promoCode
	 * @param {Boolean} needVip
	 */
	openPayTourUi:  function(promoCode, needVip = false, onSuccesFn = null) {
		const ptOptions = {option: promoCode};
		if (!Flux.Guest.isLoggedIn()) {
			VXPay.openLogin();
			return;
		}
		if (needVip && !Flux.Guest.isVip()) {
			VXPay.openAboPaytour();
			OfferAction.track(EnumAnalyticsEvents.ACTION_365_TOP_UP, EnumAnalyticsEvents.LABEL_VIP_OPEN);
			VXPay.onVIPAboSuccess(() => {
				if (typeof onSuccesFn === 'function') {
					onSuccesFn();
				}
				OfferAction.track(EnumAnalyticsEvents.ACTION_365_TOP_UP, EnumAnalyticsEvents.LABEL_PURCHASED);
				VXPay.openPaytour(ptOptions);
				VXPay.onMoneyChargeSuccess(() => {
					OfferAction.track(EnumAnalyticsEvents.ACTION_365_TOP_UP, EnumAnalyticsEvents.LABEL_SALE);
					Flux.DailyBonus.triggerLoad();
				});
			});
		} else {
			VXPay.openPaytour(ptOptions);
			OfferAction.track(EnumAnalyticsEvents.ACTION_365_TOP_UP, EnumAnalyticsEvents.LABEL_OPEN);
			VXPay.onMoneyChargeSuccess(() => {
				if (typeof onSuccesFn === 'function') {
					onSuccesFn();
				}
				OfferAction.track(EnumAnalyticsEvents.ACTION_365_TOP_UP, EnumAnalyticsEvents.LABEL_SALE);
				Flux.DailyBonus.triggerLoad();
			});
		}
	},
	consumeVoucher: function(promoCode) {
		if (!Flux.Guest.isLoggedIn()) {
			VXPay.openLogin();
			return;
		}

		const ptOptions = {pc: promoCode};

		VXPay.openPromoCode(ptOptions);
		OfferAction.track(EnumAnalyticsEvents.ACTION_365_VOUCHER, EnumAnalyticsEvents.LABEL_OPEN);
		VXPay.onSuccess(() => {
			OfferAction.track(EnumAnalyticsEvents.ACTION_365_VOUCHER, EnumAnalyticsEvents.LABEL_SALE);
			Flux.DailyBonus.triggerLoad();
		});
	},
	/**
	 * @param {Object} content
	 * @param {Boolean} isFree
	 */
	actionVideoPhotoBuyWithBonus: function(content, isFree = false) {
		OfferAction.track(EnumAnalyticsEvents.ACTION_365_BUY_ALBUM, EnumAnalyticsEvents.LABEL_OPEN);
		GuestAccess.onEnoughMoneyForShop(
			content.model.id,
			isFree ? 0 : content.dailyBonusPrice.value,
			content.ageRating && !Flux.Guest.hasAvs(),
			false,
			() => {
				const clb = (actorId, changedAlbumId) => {
					if (changedAlbumId === content.id) {
						OfferAction.track(EnumAnalyticsEvents.ACTION_365_BUY_ALBUM, EnumAnalyticsEvents.LABEL_BOUGHT);
						Flux.Gallery.removeGalleryChangeListener(clb);
						Flux.DailyBonus.triggerLoad();
					}
				};

				Flux.Gallery.addGalleryChangeListener(clb);
				Flux.Gallery.buyAlbum(content.id, {
						[EnumGA4Events.DEFAULT_PARAMETER_ITEMS__ITEM_NAME]: EnumGA4Events.DEFAULT_PARAMETER_ITEMS__ITEM_NAME__VALUE_365
					}
				);
			}
		);
	},
	actionDownloadVipWallpapers:  function(url) {
		OfferAction.track(EnumAnalyticsEvents.ACTION_365_DOWNLOAD, url);
		UrlHelper.forceDownload(url, 'wallpaper.' + url.split(/#|\?/)[0].split('.').pop().trim());
	},
	actionMerchandise:            function() {
		OfferAction.track(EnumAnalyticsEvents.ACTION_365_FORWARD, EnumAnalyticsEvents.LABEL_MERCH);
		window.open('https://vstx.de/', '_blank');
	},
	actionBecomeVipOneDay:        function(promoCode) {
		OfferAction.track(EnumAnalyticsEvents.TOP_UP, EnumAnalyticsEvents.BECOME_VIP);
		if (!Flux.Guest.isLoggedIn()) {
			VXPay.openLogin();
			return;
		}
		VXPay.onVIPAboSuccess(() => {
			Flux.DailyBonus.triggerLoad();
		});
		VXPay.openPromoCode({pc: promoCode});
	},
	/**
	 * @param {string} promoCode
	 * @param {number} topUpAmount
	 * @param {?string} vxpayText
	 */
	actionGetMessengerGift: function(promoCode, topUpAmount, vxpayText = null) {
		const texts = vxpayText ? {
			BonusItem120:   topUpAmount > 1.20 ? '' : vxpayText,
			BonusItem2500:  topUpAmount > 25 ? '' : vxpayText,
			BonusItem3000:  topUpAmount > 30 ? '' : vxpayText,
			BonusItem5000:  topUpAmount > 50 ? '' : vxpayText,
			BonusItem6000:  topUpAmount > 60 ? '' : vxpayText,
			BonusItem10000: topUpAmount > 100 ? '' : vxpayText,
			BonusItem15000: vxpayText,
		} : {};

		const selectedAmount = topUpAmount * 100;
		VXPay.openPaytour({
			option: promoCode,
			selectedAmount,
			texts,
		});
		OfferAction.track(EnumAnalyticsEvents.ACTION_365_TOP_UP, EnumAnalyticsEvents.LABEL_OPEN);
		VXPay.onMoneyChargeSuccess(() => {
			OfferAction.track(EnumAnalyticsEvents.ACTION_365_TOP_UP, EnumAnalyticsEvents.MESSENGER_GIFT);
			Flux.DailyBonus.triggerLoad();
		});
	},
};
